import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to manage page titles consistently across the application
 * @param customTitle Optional custom title to override the default header title
 * @param dependencies Array of dependencies to trigger title update
 */
export const usePageTitle = (
  customTitle?: string,
  dependencies: any[] = [],
) => {
  const location = useLocation();

  useEffect(() => {
    // If a custom title is provided, use it
    if (customTitle) {
      document.title = customTitle;
      return;
    }

    // Look for the title in the header tag or data-cy="header-title" element
    const headerTitleEl = document.querySelector('[data-cy="header-title"]');
    let headerTitle = '';
    let subTitle = '';
    let inviteName = '';

    if (headerTitleEl) {
      // get header title (h3's first text node)
      const childNodes = headerTitleEl.childNodes;
      for (let i = 0; i < childNodes.length; i++) {
        const node = childNodes[i];
        if (node.nodeType === Node.TEXT_NODE) {
          headerTitle = node.textContent?.trim() || '';
          break;
        }
      }
      // get sub title
      const subTitleEl = headerTitleEl.querySelector(
        '[data-cy="header-subtitle"]',
      );
      if (subTitleEl) {
        subTitle = subTitleEl.textContent?.trim() || '';
      }
      // get invite name
      const inviteNameEl = headerTitleEl.querySelector(
        '[data-cy="header-invite-name"]',
      );
      if (inviteNameEl) {
        inviteName = inviteNameEl.textContent?.trim() || '';
      }
    }

    let title = headerTitle;
    if (subTitle) title = `${title} ${subTitle}`;
    if (inviteName) title = `${title} ${inviteName}`;

    document.title = title || 'FileInvite';
  }, [customTitle, location.pathname, ...dependencies]);
};
